import React, { useEffect, useState } from 'react'
import {PDFDownloadLink} from '@react-pdf/renderer'
import PDFDescripcionQuirurgica from '../cirugia/descripcionQuirurgica/PDFDescripcionQuirurgica'
import { postPDFDescripcionQx } from '../../services/PaginaRuta'
import axios from "axios";
import config from "../../config";




const DescripcionQuirurgicaSuccessFull = ({setmodalOnGuardadoExitosamente,setOpenTab,item,seleccionarMedico}) => {
  const [modalOnValidarMedicoSeleccionadoRealizarDescripcionQX, setmodalOnValidarMedicoSeleccionadoRealizarDescripcionQX]=useState(false)
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('procedimientos');

  const handleCancelarClickO = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const [urgente, setUrgente] = useState('');
  const [ambulatorio, setAmbulatorio] = useState('');
  const [observacion, setObservacion] = useState('');

  const handleSubmit = (param) => {

    if(param === 1){
      const procedimiento = opciones.find(op => op.value === procedimientoSeleccionado);
  
      if (!procedimiento) return; 
    
      const nuevoProcedimiento = {
        PRCODI: procedimiento.value,             
        PRNOMB: procedimiento.label,  
        TiPrCod: tipoProcedimiento,
        TiPrDes: descTipoProcedimiento,
        OPrIndUrg: urgente,
        HCOrdAmb: ambulatorio,
        HisCPCan: cantidadPr,
        HisCpObs: observacionPr,
        HCPrStGr:'N'
      };
    
      setProcedimientos([...procedimientos, nuevoProcedimiento]);
    
      // Limpiar campos
      setCodigo('');
      setProcedimientoSeleccionado('');
      setTipoProcedimiento('');
      setDescTipoProcedimiento('');
      setUrgente('');
      setAmbulatorio('');
      setObservacion('');
      setCantidadPr('');
      setObservacionPr('');

    }else{
      const suministro = opcionesSum.find(ops => ops.value === suministroSeleccionado);
      const causaExterna = opcionesCE.find(ops => ops.value === causaSeleccionada);
      const unidad = opcionesUn.find(ops => ops.value === unidadSeleccionada);
      const via = opcionesVia.find(ops => ops.value === viaSeleccionada);

      const nuevoSuministro = {

        FsmDscMdc: suministro.label,
        MSCodi: codigoAnato,
        MSForm: forma,
        CncCd: concentracion,
        MSPrAc: principioAct,
        FSmCntDia: cantidadSum,
        FSMCauE: causaExterna.value,
        CEDETALL: causaExterna.label,
        FsTiTrDi: diasTratamiento,
        HCFSFrH: frecuencia,
        frecuencia: frecuenciaTexto,
        FsmIndAmb: ambulatorioSum,
        hisCanSum: dosis,
        HCSmUndCd: unidad.value,
        UnMdDes: unidad.label,
        HCFSVia: via.value,
        ViAplDSc: via.label,
        HISCOBSFOR: observacionSum,
        HCSmStGr: 'N',

      };

      setSuministros([...suministros, nuevoSuministro]);

      // Limpiar campos
      setCodigoSum('');
      setSuministroSeleccionado('');
      setCodigoAnato('');
      setForma('');
      setConcentracion('');
      setPrincipioAct('');
      setCantidadSum('');
      setObservacionSum('');
      setCausaSeleccionada('');
      setUnidadSeleccionada('');
      setViaSeleccionada('');
      setFrecuencia('');
      setFrecuenciaTexto('');
      setAmbulatorioSum('');
      setDiasTratamiento('');
      setDosis('');
    }

  };

  const handleEliminar = (index) => {
    const nuevosProcedimientos = [...procedimientos];
    nuevosProcedimientos.splice(index, 1);
    setProcedimientos(nuevosProcedimientos);
  };

  const handleEliminarSum = (index) => {
    const nuevosSSuministros = [...suministros];
    nuevosSSuministros.splice(index, 1);
    setSuministros(nuevosSSuministros);
  };

  const [dataDescripcionQx, setdataDescripcionQx]=useState({
            "MCDpto": "",
            "EMPCOD": "",
            "MCDnom": "",
            "EmpNit": "",
            "EmpRazSoc": "",
            "EmpLogo": "",
            "MCDptCod": "",
            "MCCiuCod": "",
            "MDCodM": "",
            "MDCodD": "",
            "MDNomD": "",
            "MDNomM": "",
            "ProCirCod": "",
            "ProHorI": "",
            "MPCedu": "",
            "MPTDoc": "",
            "MPNOMC": "",
            "ProCons": "",
            "ProNcons": "",
            "ProFec": "",
            "PosTpHerd": "",
            "ProNEPS": "",
            "MPFchN": "",
            "ProSit": "",
            "ProFliSol": "",
            "ProCtvIn": "",
            "ProEPS": "",
            "MESITRIA": "",
            "PrcMulOpc": "",
            "PrcMulTip": "",
            "MTUCod": "",
            "MTCodP": "",
            "MENNIT": "",
            "MTNomP": "",
            "MTUDes": "",
            "TFcCodPab": "",
            "TFcCodCam": "",
            "ClaPro": "",
            "MPCodP": "",
            "MPNomP": "",
            "ViaCod": "",
            "MedCod": "",
            "EspcCod": "",
            "MedNom": "",
            "CrgEst": "",
            "CrgDes": "",
            "CrgCnt": "",
            "ViaDsc": "",
            "EspcDes": "",
            "CrgCod": "",
            "MTUCo1": "",
            "PTCodi": "",
            "MEPPVig": "",
            "PTApMo": "",
            "ForLiqCod": "",
            "TrfCod": "",
            "PTRecarg": "",
            "HomProCnt": "",
            "HomProLH": "",
            "HomProVlr": "",
            "HorIniCir": "",
            "HorFinCir": "",
            "DiaEnt": "",
            "DiaSal": "",
            "TipHer": "",
            "CanSan": "",
            "TiePer": "",
            "TieClamp": "",
            "ViaIng": "",
            "EstCir": "",
            "TipAne": "",
            "CscIng": "",
            "DQxCod": "",
            "DesCir": "",
            "DesCom": "",
            "CodEsp": "",
            "DesDatMUn": "",
            "DesInNNIS": "",
            "DesIndCom": "",
            "FECINICIR": "",
            "TpAnsCod": "",
            "TpAnsDsc": "",
            "CodMed2":"",
            "CodEsp2":"",
            "DiligencioFormularioCirujanoUno":"",
            "DiligencioFormularioCirujanoDos":"",
            "DesHalEnc2":"",
            "DesCir2":""


    })
    const [dataOtrosParticipantes, setdataOtrosParticipantes]=useState([])
    const [loading, setloading]=useState(false)
    const [dataPreoperatorio, setdataPreoperatorio]=useState([])
    const [dataPostOperatorio,setdataPostOperatorio]=useState([])
    const [dataProcedimientosQx, setdataProcedimientosQx]=useState([])
    const [dataDescripcionQxCirujanos, setdataDescripcionQxCirujanos]=useState([])
    const handleCancelarClick=()=>{
      // setmodalOnGuardadoExitosamente(false)
      // setOpenTab(2)

      setTimeout(() => {
        setmodalOnGuardadoExitosamente(false)
        setOpenTab(2)        
      }, 500);
    }

    const handleOnclickDescripcion=()=>{
  
      setmodalOnValidarMedicoSeleccionadoRealizarDescripcionQX(true)
    }



    useEffect(()=>{
      setloading(false)
      const dataParaDescripcionQx={
        "EMPCOD":usuarioInfo.Empresa,
        "MCDpto":usuarioInfo.Sede,
        "MDCodM":"1",
        "ProCirCod":item.ProCirCod
      }
      console.log(item,'itemmmm')
      postPDFDescripcionQx(dataParaDescripcionQx).then((res)=>{
        setloading(true)
        if(res.data.error){
          console.log('Error')

        }else{
          console.log(res.data,'data pdf descripcion qx')
          console.log(res.data.DatosEmpresaAndUser[0],'data pdf descripcion qx DatosEmpresaAndUser')
          setdataDescripcionQx(res.data.DatosEmpresaAndUser[0])
          setdataOtrosParticipantes(res.data.otrosAyudantes)
          setdataPreoperatorio(res.data.otrosDoloresEntrada)
          setdataPostOperatorio(res.data.otrosDoloresSalida)
          setdataProcedimientosQx(res.data.variosProcedimientosUVR)
          setdataDescripcionQxCirujanos(res.data.descripcionQxCirujanos)
        }
        
      
      })
    },[])
    

    const [codigo, setCodigo] = useState("");
    const [opciones, setOpciones] = useState([]);
    const [procedimientosRaw, setProcedimientosRaw] = useState([]);
    const [tipoProcedimiento, setTipoProcedimiento] = useState("");
    const [descTipoProcedimiento, setDescTipoProcedimiento] = useState("");
    const [cantidadPr, setCantidadPr] = useState("");
    const [observacionPr, setObservacionPr] = useState("");
    const [procedimientoSeleccionado, setProcedimientoSeleccionado] = useState("");
  
    const handleKeyDown = async (e) => {
      if (e.key === "Tab") {
        try {
          let apiUrl = config.API_URL;
          const response = await axios.get(apiUrl + `/api/admisiones/listas/listaProcedimientos?PrNomb=${codigo}`);
          if (response.status === 200 && Array.isArray(response.data.data)) {
            const data = response.data.data;
            setProcedimientosRaw(data); // Guardamos todos los datos originales
            setTipoProcedimiento("");
            setDescTipoProcedimiento("");
  
            const opcionesFormateadas = data.map(item => ({
              value: item.PRCODI.trim(),
              label: item.PrNomb.trim()
            }));
            setOpciones(opcionesFormateadas);
  
            if (data.length > 1) {
              const item = data[0];
              setProcedimientoSeleccionado(item.PRCODI.trim());
              setCodigo("");
              /* setTipoProcedimiento(item.PRCODI.trim());
              setDescTipoProcedimiento(item.PRCODI.trim()); */
            }
          }
        } catch (error) {
          console.error("Error al obtener procedimientos:", error);
        }
      }
    };

    const handleSelectChange = (e) => {
      const seleccionado = e.target.value;
      setProcedimientoSeleccionado(seleccionado);
  
      const item = procedimientosRaw.find(proc => proc.PRCODI.trim() === seleccionado);
      if (item) {
        setTipoProcedimiento(item.TpPrCd.trim());
        setDescTipoProcedimiento(item.TiPrDes.trim());
        
        
      } else {
        setTipoProcedimiento("");
        setDescTipoProcedimiento("");
      }


    };

    const [procedimientos, setProcedimientos] = useState([]);
    const [suministros, setSuministros] = useState([]);
    

    const handleGuardarNota = async () => {
      
      let idClinica = config.ID_CLINICA;
    
      try {

        //si procedimientos están vacíos, no se realiza la llamada a la API
        if(procedimientos.filter(proc => proc.HCPrStGr !== "O").length > 0){
          // Consumir API DE RCF PARA ORDENAMIENTO
          const ordenProcedimientos = procedimientos.filter(proc => proc.HCPrStGr !== "O").map(proc => ({
            surgical_shift: {}, // Siempre vacío
            code: proc.PRCODI,
            quantity: parseInt(proc.HisCPCan) || 1,
            observations: proc.HisCpObs || "Ninguna",
            type_procedure: parseInt(proc.TiPrCod), // asegúrate de que TiPrDes sea un número
            name: proc.PRNOMB,
            urgency: proc.OPrIndUrg === "S",
            ambulatory: proc.HCOrdAmb === "S"
          }));
        
          const json_o_F = {
            role: "GN",
            document: item['MPCedu'].trim(),
            professional_specialty: item['ProEspSe1'].trim(),
            evolution: "el texto de evolucion con antecedentes",
            clinic_id: idClinica,
            professional_id: item['ProPerSe1'].trim(),
            document_type: item['MPTDoc'].trim(),
            sede: item['ProCSede'].trim(),
            admission_id: item['ProCtvIn'].trim(),
            order: ordenProcedimientos
          };
          const responsePost = await fetch('http://172.16.213.54:81/clinical_record/evoluciones/paciente_general/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(json_o_F)
          });
  
          const resultPost = await responsePost.json();
  
          if (responsePost.ok) {
            console.log('Nota guardada correctamente:', resultPost);
          } else {
            console.error('Error en la respuesta del POST:', resultPost);
          }
  
          let apiUrl = config.API_URL;
          const response = await fetch(apiUrl + '/api/notasPosoperatorias/tablas/procedimientosOrdenados?HISCKEY='+item['MPCedu'].trim()+'&HISTipDoc='+item['MPTDoc'].trim()+'&HISCSEC='+resultPost.folio); 
          const result = await response.json();
      
          if (result.success) {
            setProcedimientos(result.data);
          } else {
            console.error('Respuesta incorrecta:', result);
          }
        }else{

          //SUMIISTROS
          const formulacionSuministros = suministros
            .filter(item => item.HCSmStGr !== "C") // Excluir los ya ordenados
            .map(item => ({
              code: item.MSCodi.trim(),                    // Código anato
              shape: item.MSForm.trim(),                  // Forma
              external_cause: item.FSMCauE.trim(),        // Causa externa
              unit_measurement: item.HCSmUndCd.trim(),    // Código unidad medida
              concentration: item.CncCd.trim(),           // Concentración
              ambulatory: item.FsmIndAmb === "S",         // Booleano
              requested_amount: item.FSmCntDia.trim(),    // Cantidad solicitada
              via: item.HCFSVia.trim(),                   // Código vía administración
              frequency: item.HCFSFrH.trim(),             // Código frecuencia
              dose: item.hisCanSum,      // Dosis
              observations: item.HISCOBSFOR?.trim() || "Ninguna",
              name: item.FsmDscMdc.trim(),                // Nombre medicamento
              active_principle: item.MSPrAc.trim(),       // Principio activo
              treatment_days: parseInt(item.FsTiTrDi) || 1,
              status: 'C'                                 // Estado
            }));

          const payloadSuministros = {
            role: "GN",
            document: item['MPCedu'].trim(),
            professional_specialty: item['ProEspSe1'].trim(),
            evolution: "el texto de evolucion con antecedentes",
            clinic_id: idClinica,
            professional_id: item['ProPerSe1'].trim(),
            document_type: item['MPTDoc'].trim(),
            sede: item['ProCSede'].trim(),
            admission_id: item['ProCtvIn'].trim(),
            formulation: formulacionSuministros
          };

          console.log(payloadSuministros, 'payload suministros')

          const responsePost = await fetch('http://172.16.213.54:81/clinical_record/evoluciones/paciente_general/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payloadSuministros)
          });
  
          const resultPost = await responsePost.json();
  
          if (responsePost.ok) {
            console.log('Nota guardada correctamente:', resultPost);
          } else {
            console.error('Error en la respuesta del POST:', resultPost);
          }

          let apiUrl = config.API_URL;
          const response = await fetch(apiUrl + '/api/notasPosoperatorias/tablas/suministrosformulados?HISCKEY='+item['MPCedu'].trim()+'&HISTipDoc='+item['MPTDoc'].trim()+'&HISCSEC='+resultPost.folio); 
          const resultSum = await response.json();
      
          if (resultSum.success) {
            setSuministros(resultSum.data);
          } else {
            console.error('Respuesta incorrecta:', resultSum);
          }
        }


      } catch (error) {
        console.error('Error al consumir la API:', error);
      }
    };

    //SUMINISTROS
    const [codigoSum, setCodigoSum] = useState("");
    const [opcionesSum, setOpcionesSum] = useState([]);
    const [opcionesCE, setOpcionesCE] = useState([]);
    const [opcionesUn, setOpcionesUn] = useState([]);
    const [opcionesVia, setOpcionesVia] = useState([]);
    const [suministrosRaw, setSuministrosRaw] = useState([]);
    const [causaExternaRaw, setCausaExternaRaw] = useState([]);
    const [unidadRaw, setCausaUnidadRaw] = useState([]);
    const [viaRaw, setViaRaw] = useState([]);
    const [suministroSeleccionado, setSuministroSeleccionado] = useState("");
    const [causaSeleccionada, setCausaSeleccionada] = useState("");
    const [unidadSeleccionada, setUnidadSeleccionada] = useState("");
    const [viaSeleccionada, setViaSeleccionada] = useState("");
    const [codigoAnato, setCodigoAnato] = useState("");
    const [forma, setForma] = useState("");
    const [concentracion, setConcentracion] = useState("");
    const [principioAct, setPrincipioAct] = useState("");
    const [observacionSum, setObservacionSum] = useState("");
    const [cantidadSum, setCantidadSum] = useState("");
    const [frecuencia, setFrecuencia] = useState([]);
    const [frecuenciaTexto, setFrecuenciaTexto] = useState("");
    const [diasTratamiento, setDiasTratamiento] = useState("");
    const [ambulatorioSum, setAmbulatorioSum] = useState([]);
    const [dosis, setDosis] = useState("");

    const handleKeyDownSum = async (e) => {
      console.log(e.key, 'key')
      if (e.key === "Tab") {
        try {
          let apiUrl = config.API_URL;
          const response = await axios.get(apiUrl + `/api/suministros/parametros/indexSuministros?MSCodi=${codigoSum}`);
          if (response.status === 200 && Array.isArray(response.data)) {
            const data = response.data;
            setSuministrosRaw(data); // Guardamos todos los datos originales
  
            const opcionesFormateadas = data.map(item => ({
              value: item.MSDesc.trim(),
              label: item.MSDesc.trim()
            }));
            setOpcionesSum(opcionesFormateadas);
  
            if (data.length > 1) {
              const item = data[0];
              setSuministroSeleccionado(item.MSDesc.trim());
              setCodigoSum("");
            }
          }

          const consExt = await axios.get(apiUrl + `/api/admisiones/listas/causaExterna`);

          if (consExt.status === 200 && Array.isArray(consExt.data)) {
            const dataCE = consExt.data;
            setCausaExternaRaw(dataCE); // Guardamos todos los datos originales
  
            const opcionesFormateadasCE = dataCE.map(itemCE => ({
              value: itemCE.CECODIGO.trim(),
              label: itemCE.CEDETALL.trim()
            }));
            setOpcionesCE(opcionesFormateadasCE);


            if (dataCE.length > 1) {
              const itemCE = dataCE[0];
              setCausaSeleccionada(itemCE.CECODIGO.trim());
            }
          }

          const consUnidad = await axios.get(apiUrl + `/api/suministros/producto/unidades`);

          if (consUnidad.status === 200 && Array.isArray(consUnidad.data)) {
            const dataUnidad = consUnidad.data;
            setCausaUnidadRaw(dataUnidad); // Guardamos todos los datos originales
  
            const opcionesFormateadasUn = dataUnidad.map(imteUn => ({
              value: imteUn.UnMdCod.trim(),
              label: imteUn.UnMdDes.trim()
            }));
            setOpcionesUn(opcionesFormateadasUn);


            if (dataUnidad.length > 1) {
              const imteUn = dataUnidad[0];
              setCausaSeleccionada(imteUn.UnMdCod.trim());
            }
          }

          const consVia = await axios.get(apiUrl + `/api/suministros/producto/viaAplicacion`);

          if (consVia.status === 200 && Array.isArray(consVia.data)) {
            const dataVia = consVia.data;
            setViaRaw(dataVia); // Guardamos todos los datos originales
  
            const opcionesFormateadasVia = dataVia.map(imteVia => ({
              value: imteVia.ViAplCod.trim(),
              label: imteVia.ViAplDSc.trim()
            }));
            setOpcionesVia(opcionesFormateadasVia);


            if (dataVia.length > 1) {
              const imteVia = dataVia[0];
              setViaSeleccionada(imteVia.ViAplCod.trim());
            }
          }



        } catch (error) {
          console.error("Error al obtener suministros:", error);
        }
      }
    };

    const handleSelectChangeSum = (e) => {
      const seleccionado = e.target.value;
      setSuministroSeleccionado(seleccionado);

      const item = suministrosRaw.find(sum => sum.MSDesc.trim() === seleccionado);
      if (item) {
        setCodigoAnato(item.MSCodi.trim());
        setForma(item.MSForm.trim());
        setConcentracion(item.CncCd.trim());
        setPrincipioAct(item.MSPrAc.trim());
        setUnidadSeleccionada(item.producto.MsUndApl?.trim() || ""); // <- Aquí se setea la unidad
      } else {
        setCodigoAnato("");
        setForma("");
        setConcentracion("");
        setPrincipioAct("");
        setUnidadSeleccionada(""); // <- Limpiar unidad si no se encuentra
      }
    };

    
    const handleSelectChangeCE = (e) => {
      const seleccionado = e.target.value;
      setCausaSeleccionada(seleccionado);
      setCausaExternaRaw(seleccionado); 
      
    };
    
    const handleSelectChangeUn = (e) => {
      const seleccionado = e.target.value;
      setUnidadSeleccionada(seleccionado);
      setCausaUnidadRaw(seleccionado); 
      
    };
    
    const handleSelectChangeVia = (e) => {
      const seleccionado = e.target.value;
      setViaSeleccionada(seleccionado);
      setViaRaw(seleccionado); 
      
    };
    
     
    
  return (
    <>
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto pt-20 bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-1rem)] max-w-xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md">
            <h5
              className="text-xl font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            >
              
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
         
  <div className="mt-3 text-center">
		<div
			className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
		>
			<svg
				className="h-6 w-6 text-green-600"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					d="M5 13l4 4L19 7"
				></path>
			</svg>
		</div>
		<h3 className="text-lg leading-6 font-medium text-gray-900">La información fue registrada con éxito!</h3>
		<div className="mt-2 px-7 py-3">
			<p className="text-sm text-gray-500">
				
			</p>
		</div>
		<div className="items-center px-4 py-3">
      <PDFDownloadLink document={<PDFDescripcionQuirurgica dataDescripcionQx={dataDescripcionQx} dataOtrosParticipantes={dataOtrosParticipantes} dataPostOperatorio={dataPostOperatorio} dataPreoperatorio={dataPreoperatorio} dataProcedimientosQx={dataProcedimientosQx} seleccionarMedico={seleccionarMedico} dataDescripcionQxCirujanos={dataDescripcionQxCirujanos}/>} fileName="DescripcionQXlllllllllllllllll.pdf">
			<button
                type="button"
             onClick={handleCancelarClick}
				id="ok-btn"
				className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
			>
				OK
			</button>
      </PDFDownloadLink>
      <button
        type="button"
        onClick={handleCancelarClickO}
        id="ok-btn"
        className="mt-4 px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
      >
        AGREGAR NOTA POSOPERATORIA
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-xl w-[95%] h-[90vh] overflow-y-auto shadow-2xl relative">
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-xl"
              onClick={handleCloseModal}
            >
              ✖
            </button>

            <h2 className="text-2xl font-bold mb-6 text-center">
              Nueva Nota de Ordenamientos Posoperatorios
            </h2>

            <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200">
              <ul className="flex flex-wrap justify-center -mb-px">
                <li className="me-4">
                  <a
                    href="#"
                    onClick={() => handleTabChange('procedimientos')}
                    className={`inline-block p-4 border-b-2 rounded-t-lg ${
                      activeTab === 'procedimientos'
                        ? 'text-blue-600 border-blue-600'
                        : 'border-transparent hover:text-gray-600 hover:border-gray-300'
                    }`}
                  >
                    Procedimientos
                  </a>
                </li>
                <li className="me-4">
                  <a
                    href="#"
                    onClick={() => handleTabChange('suministros')}
                    className={`inline-block p-4 border-b-2 rounded-t-lg ${
                      activeTab === 'suministros'
                        ? 'text-blue-600 border-blue-600'
                        : 'border-transparent hover:text-gray-600 hover:border-gray-300'
                    }`}
                  >
                    Suministros
                  </a>
                </li>
              </ul>
            </div>

            <form className="mt-6">
              {activeTab === 'procedimientos' ? (
                <div className="mb-4">
                        <div class="grid gap-6 mb-6 md:grid-cols-2">
                            <div>
                                <label for="codigo_procedimiento" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Procedimiento</label>
                                <input type="text" id="codigo_procedimiento"value={codigo}
                                        onChange={(e) => setCodigo(e.target.value)}
                                        onKeyDown={handleKeyDown} name="codigo_procedimiento" 
                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                            </div>
                            <div>
                                <label for="nombre_procedimiento" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Nombre Procedimiento</label>
                                <select id="nombre_procedimiento"
                                      name="nombre_procedimiento"
                                      value={procedimientoSeleccionado}
                                      onChange={handleSelectChange} 
                                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                      <option value="">Seleccione una opción</option>
                                    {opciones.map((op, index) => (
                                      <option key={index} value={op.value}>{op.value + '-' +op.label}</option>
                                    ))}
                                  </select>
                            </div>
                            <div>
                                <label for="tipo_procedimiento" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Tipo de Procedimiento</label>
                                <input type="text"
                                    id="tipo_procedimiento"
                                    name="tipo_procedimiento"
                                    value={tipoProcedimiento}
                                    readOnly 
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required
                                />
                            </div>
                            <div>
                                <label for="dec_tipo_procedimiento" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Descripción Tipo Procedimiento</label>
                                <input  type="text"
                                    id="dec_tipo_procedimiento"
                                    name="dec_tipo_procedimiento"
                                    value={descTipoProcedimiento}
                                    readOnly
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required 
                                />
                            </div>
                            <div>
                              <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">URGENTE?</label>
                              <select id="urgente" name="urgente" 
                                value={urgente}
                                onChange={(e) => setUrgente(e.target.value)}
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option selected>Seleccione una opcion</option>
                                <option value="S">Si</option>
                                <option value="N">No</option>
                              </select>
                            </div>  
                            <div>
                              <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">AMBULATORIO?</label>
                              <select id="ambulatorio" name="ambulatorio" 
                                value={ambulatorio}
                                onChange={(e) => setAmbulatorio(e.target.value)}
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option selected>Seleccione una opcion</option>
                                <option value="S">Si</option>
                                <option value="N">No</option>
                              </select>
                            </div>
                        </div>
                        <div class="grid gap-6 mb-6 md:grid-cols-1">
                          <div>
                            <label for="cantidadPr" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Cantidad</label>
                            <input type="text" id="cantidadPr" name="cantidadPr"
                              value={cantidadPr}
                              onChange={(e) => setCantidadPr(e.target.value)}
                              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                          </div>
                          <label for="observacion_pr" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Observación</label>
                          <textarea id="observacion_pr" name="observacion_pr" rows="4" value={observacionPr} onChange={(e) => setObservacionPr(e.target.value)} class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></textarea>
                        </div>
                        <div className="flex justify-end mb-6">
                          <button
                            type="button"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            onClick={() => handleSubmit(1)}
                          >
                            Agregar Procedimiento
                          </button>
                        </div>

                  <div className="mt-4">
                  <h2 className="text-lg font-semibold mb-2">Procedimientos Ordenados</h2>
                  <table className="min-w-full border border-gray-300 text-sm text-left text-gray-700 dark:text-gray-200">
                    <thead className="bg-gray-100 dark:bg-gray-700">
                      <tr>
                        <th className="border px-4 py-2">Código Prodecimiento</th>
                        <th className="border px-4 py-2">Nombre Procedimiento</th>
                        <th className="border px-4 py-2">Tipo Procedimiento</th>
                        <th className="border px-4 py-2">Des Procedimiento</th>
                        <th className="border px-4 py-2">Urgente</th>
                        <th className="border px-4 py-2">Ambulatorio</th>
                        <th className="border px-4 py-2">Cantidad</th>
                        <th className="border px-4 py-2">Observacion</th>
                        <th className="border px-4 py-2">Estado</th>
                        <th className="border px-4 py-2 text-center">Acciones</th> 
                      </tr>
                    </thead>
                    <tbody>
                      {procedimientos.map((item, index) => (
                        <tr key={index}>
                          <td className="border px-4 py-2">{item.PRCODI.trim()}</td>
                          <td className="border px-4 py-2">{item.PRNOMB.trim()}</td>
                          <td className="border px-4 py-2">{item.TiPrCod.trim()}</td>
                          <td className="border px-4 py-2">{item.TiPrDes.trim()}</td>
                          <td className="border px-4 py-2">{item.OPrIndUrg.trim()}</td>
                          <td className="border px-4 py-2">{item.HCOrdAmb.trim()}</td>
                          <td className="border px-4 py-2">{item.HisCPCan.trim()}</td>
                          <td className="border px-4 py-2">{item.HisCpObs.trim()}</td>
                          <td className="border px-4 py-2">{item.HCPrStGr.trim()}</td>
                          <td className="border px-4 py-2 text-center">
                            <button
                              onClick={() => handleEliminar(index)}
                              className="text-red-600 hover:text-red-800 font-semibold"
                            >
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>


              ) : (


                <div className="mb-12">
                    <div class="grid gap-6 mb-6 md:grid-cols-2">
                      <div>
                        <label for="codigo_suministro" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Suministro</label>
                        <input type="text" id="codigo_suministro"value={codigoSum}
                                onChange={(e) => setCodigoSum(e.target.value)}
                                onKeyDown={handleKeyDownSum} name="codigo_suministro" 
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                      </div>
                      <div>
                          <label for="nombre_suministro" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Nombre Suministro</label>
                          <select id="nombre_suministro"
                                name="nombre_suministro"
                                value={suministroSeleccionado}
                                onChange={handleSelectChangeSum} 
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option value="">Seleccione una opción</option>
                              {opcionesSum.map((op, index) => (
                                <option key={index} value={op.value}>{op.label}</option>
                              ))}
                            </select>
                      </div>
                    </div>
                    <div class="grid gap-6 mb-6 md:grid-cols-4">
                        <div>
                            <label for="codigo_anato" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Codigo Anato</label>
                            <input type="text" id="codigo_anato" name="codigo_anato" value={codigoAnato} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                        </div>
                        <div>
                            <label for="forma" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Forma Farmaceutica</label>
                            <input type="text" id="forma" name="forma" value={forma} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                        </div>
                        <div>
                            <label for="concentracion" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Concentracion</label>
                            <input type="text" id="concentracion" name="concentracion" value={concentracion} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                        </div>
                        <div>
                            <label for="principio" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Principio Activo</label>
                            <input type="text" id="principio" name="principio" value={principioAct} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                        </div>
                    </div>
                    <div class="grid gap-6 mb-6 md:grid-cols-4">
                      <div>
                        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Causa Externa</label>
                        <select id="causa_externa" name="causa_externa" 
                          value={causaSeleccionada} 
                          onChange={handleSelectChangeCE} 
                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                          <option value="">Seleccione una opción</option>
                              {opcionesCE.map((op, index) => (
                                <option key={index} value={op.value}>{op.label}</option>
                              ))}
                        </select>
                      </div>
                      <div>
                          <label for="dias_tratamiento" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Dias de Tratamiento</label>
                          <input type="text" id="dias_tratamiento" name="dias_tratamiento" 
                            value={diasTratamiento}
                            onChange={(e) => setDiasTratamiento(e.target.value)}
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                      </div>
                       <div>
                          <label for="frecuencia" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Frecuencia</label>
                          <select id="frecuencia" name="frecuencia"
                            value ={frecuencia}
                             onChange={(e) => {
                                const valor = e.target.value;
                                const texto = e.target.options[e.target.selectedIndex].text;
                                setFrecuencia(valor);
                                setFrecuenciaTexto(texto);
                              }}
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value="">Seleccione una opción</option>
                            <option value="74">7 Dias</option>
                            <option value="91">15 Minutos</option>
                            <option value="92">30 Minutos</option>
                            <option value="78">14 Dias</option>
                            <option value="12">12 horas</option>
                            <option value="6">6 Horas</option>
                            <option value="8">8 Horas</option>
                            <option value="2">2 Horas</option>
                            <option value="1">1 Hora</option>
                            <option value="95">Ahora</option>
                            <option value="90">Bolo</option>
                            <option value="94">5 Minutos</option>
                            <option value="24">24 Horas</option>
                            <option value="93">Dosis Unica</option>
                            <option value="79">21 Dias</option>
                            <option value="80">28 Dias</option>
                            <option value="99">Inf. Continua</option>
                            <option value="3">3 Horas</option>
                            <option value="4">4 Horas</option>
                          </select>
                        </div>

                      <div>
                        <label for="ambulatorio" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">AMBULATORIO?</label>
                        <select id="ambulatorio" name="ambulatorio" 
                          value={ambulatorioSum}
                          onChange={(e) => setAmbulatorioSum(e.target.value)}
                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                          <option selected>Seleccione una opcion</option>
                          <option value="S">Si</option>
                          <option value="N">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="grid gap-6 mb-6 md:grid-cols-4">
                      <div>
                          <label for="dosis" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Dosis</label>
                          <input type="text" id="dosis" name="dosis" 
                            value={dosis}
                            onChange={(e) => setDosis(e.target.value)}
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                      </div>
                      <div>
                        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Unidad</label>
                        <select id="unidad" name="unidad" 
                          value={unidadSeleccionada} 
                          onChange={handleSelectChangeUn} 
                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                          <option value="">Seleccione una opción</option>
                              {opcionesUn.map((op, index) => (
                                <option key={index} value={op.value}>{op.label}</option>
                              ))}
                        </select>
                      </div>
                      <div>
                        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Via</label>
                        <select id="via" name="via" 
                          value={viaSeleccionada} 
                          onChange={handleSelectChangeVia} 
                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                          <option value="">Seleccione una opción</option>
                              {opcionesVia.map((op, index) => (
                                <option key={index} value={op.value}>{op.label}</option>
                              ))}
                        </select>
                      </div>
                      <div>
                          <label for="cantidad" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Cantidad</label>
                          <input type="text" id="cantidad" name="cantidad" 
                            value={cantidadSum}
                            onChange={(e) => setCantidadSum(e.target.value)}
                           class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-6px p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  required />
                      </div>
                    </div>
                    <div class="grid gap-6 mb-6 md:grid-cols-1">
                      <label for="observacion_sum" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left">Observación</label>
                      <textarea id="observacion_sum" name="observacion_sum" rows="4" 
                        value={observacionSum}
                        onChange={(e) => setObservacionSum(e.target.value)}
                        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></textarea>
                    </div>
                    <div className="flex justify-end mb-6">
                      <button
                        type="button"
                        onClick={() => handleSubmit(2)}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        Agregar Suministro
                      </button>
                    </div>

                <div className="mt-6">
                  <h2 className="text-lg font-semibold mb-2">Suministros Formulados</h2>
                  <table className="min-w-full border border-gray-300 text-sm text-left text-gray-700 dark:text-gray-200">
                    <thead className="bg-gray-100 dark:bg-gray-700">
                      <tr>
                        
                        <th className="border px-4 py-2">Nombre Suministro</th>
                        <th className="border px-4 py-2">Anato</th>
                        <th className="border px-4 py-2">Forma</th>
                        <th className="border px-4 py-2">Concentracion</th>
                        <th className="border px-4 py-2">Ppio Activo</th>
                        <th className="border px-4 py-2">Cantidad</th>
                        <th className="border px-4 py-2" hidden>Cod Externa</th>
                        <th className="border px-4 py-2" >Causa Externa</th>
                        <th className="border px-4 py-2">Dias Tto</th>
                        <th className="border px-4 py-2" hidden>Cod Frecuencia</th>
                        <th className="border px-4 py-2">Frecuencia</th>
                        <th className="border px-4 py-2">Amb</th>
                        <th className="border px-4 py-2">Dosis</th>
                        <th className="border px-4 py-2" hidden> Cod Unidad</th>
                        <th className="border px-4 py-2">Unidad</th>
                        <th className="border px-4 py-2" hidden>Cod Via</th>
                        <th className="border px-4 py-2">Via</th>
                        <th className="border px-4 py-2">Observacion</th>
                        <th className="border px-4 py-2">Estado</th>
                        <th className="border px-4 py-2 text-center">Acciones</th> 
                      </tr>
                    </thead>
                    <tbody>
                      {suministros.map((item, index) => (
                        <tr key={index}>
                          <td className="border px-4 py-2">{item.FsmDscMdc.trim()}</td>
                          <td className="border px-4 py-2">{item.MSCodi.trim()}</td>
                          <td className="border px-4 py-2">{item.MSForm.trim()}</td>
                          <td className="border px-4 py-2">{item.CncCd.trim()}</td>
                          <td className="border px-4 py-2">{item.MSPrAc.trim()}</td>
                          <td className="border px-4 py-2">{item.FSmCntDia.trim()}</td>
                          <td className="border px-4 py-2" hidden> {item.FSMCauE.trim()}</td>
                          <td className="border px-4 py-2">{item.CEDETALL.trim()}</td>
                          <td className="border px-4 py-2">{item.FsTiTrDi.trim()}</td>
                          <td className="border px-4 py-2" hidden> {item.HCFSFrH.trim()}</td>
                          <td className="border px-4 py-2">{item.frecuencia.trim()}</td>
                          <td className="border px-4 py-2">{item.FsmIndAmb.trim()}</td>
                          <td className="border px-4 py-2">{item.hisCanSum.trim()}</td>
                          <td className="border px-4 py-2" hidden> {item.HCSmUndCd.trim()}</td>
                          <td className="border px-4 py-2">{item.UnMdDes.trim()}</td>
                          <td className="border px-4 py-2" hidden> {item.HCFSVia.trim()}</td>
                          <td className="border px-4 py-2">{item.ViAplDSc.trim()}</td>
                          <td className="border px-4 py-2">{item.HISCOBSFOR.trim()}</td>
                          <td className="border px-4 py-2">{item.HCSmStGr.trim()}</td>

                          <td className="border px-4 py-2 text-center">
                            <button
                              onClick={() => handleEliminarSum(index)}
                              className="text-red-600 hover:text-red-800 font-semibold"
                            >
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              )}
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={handleGuardarNota}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                >
                  Guardar Nota
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
		</div>
	</div>
          {/* <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              //onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div> */}
        </div>
      </div>
      {
            loading? 
            null:
            <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
        
          }
    </div>
    </>
  )
}

export default DescripcionQuirurgicaSuccessFull
